import { apiClient } from "@/services/apiClient";
import type { HomeSliderItem } from "../types/home";

const PUBLIC_API_CONFIG = {
  skipAuthRefresh: true,
} as const;

export const getHomeSlidersApi = async (locale: string, regionSlug?: string): Promise<HomeSliderItem[]> => {
  const response = await apiClient.get("/api/home-sliders", {
    ...PUBLIC_API_CONFIG,
    params: {
      locale,
      region_slug: regionSlug || undefined,
    },
  });

  return normalizeHomeSliders(response.data);
};

function normalizeHomeSliders(payload: unknown): HomeSliderItem[] {
  if (!Array.isArray(payload)) {
    throw new Error("Invalid home sliders response");
  }

  return payload
    .filter(isHomeSliderItem)
    .map((item) => ({
      id: item.id,
      title: item.title.trim(),
      image: item.image,
      mobile_image: item.mobile_image || item.image,
      link: item.link,
    }));
}

function isHomeSliderItem(value: unknown): value is HomeSliderItem {
  if (!isRecord(value)) {
    return false;
  }

  return (
    typeof value.id === "number" &&
    isNonEmptyString(value.title) &&
    (value.image === null || typeof value.image === "string") &&
    (value.mobile_image === undefined || value.mobile_image === null || typeof value.mobile_image === "string") &&
    (value.link === null || typeof value.link === "string")
  );
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function isNonEmptyString(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0;
}
